export enum GenderType {
  MALE = "M",
  FEMALE = "F",
}

export enum PersonType {
  FISICA = "FISICA",
  JURIDICA = "JURIDICA",
}

export enum ProductType {
  JACKET = "JACKET",
  GOWN = "GOWN",
  PANTS = "PANTS",
  VEST = "VEST",
}

export enum RentalType {
  SUIT = "SUIT",
  GOWN = "GOWN",
}

export enum RentalStatus {
  INCOMPLETE = "INCOMPLETE",
  COMPLETE = "COMPLETE",
  ON_STREET = "ON_STREET",
  FINISHED = "FINISHED",
  CANCELED = "CANCELED",
}

export enum StockStatus {
  AVAILABLE = "AVAILABLE",
  RENTED = "RENTED",
  MAINTENANCE = "MAINTENANCE",
  ON_STREET = "ON_STREET",
}

export enum StockCondition {
  NEW = "NEW",
  GOOD = "GOOD",
  REGULAR = "REGULAR",
  POOR = "POOR",
}

export enum InvoiceStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export enum InvoiceType {
  RENTAL = "RENTAL",
  EXTENSION = "EXTENSION",
  PENALTY = "PENALTY",
}

export enum InvoicePaymentMethod {
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  PIX = "PIX",
  BANK_TRANSFER = "BANK_TRANSFER",
}

export enum RateType {
  SUIT = "SUIT",
  GOWN = "GOWN",
  SHOES = "SHOES",
}
